<div class="booking-box custom-bookingbox">
    <div class="stats-booking-wrapper stats-main-outer">
        <div class="stats-main-left">
            <div class="common-flex-basis custom-grow">
                <div class="booking-main booking-line">
                    <div class="booking-text">
                        <div class="new-bookingtext">
                            <div class="new-bookingtext">
                                <img src="assets/images/revenues-icon.svg" alt=""/>
                                <div class="slot-outer">
                                    <h4>Revenue</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="booking-status revenu-common">
                        <ul class="total-booking1">
                            <li>
                                <h5>
                                    ${{(totalRevenue || 0) | number:'1.2-2'}}
                                </h5>
                            </li>
                            <li (click)="revenueClick()">
                                <div class="arrow-icon"><img src="assets/images/grey-arrow.svg" alt=""/></div>
                            </li>
                        </ul>
                        <div class="revenue-fee-inner">
                            <p>+ Txn Fees: ${{ (revenueWithTransactionFees || 0) | numberFormat }}</p>
                            <p>+ Taxes: ${{ (revenueWithTaxAndFees || 0) | numberFormat }}</p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="stats-main-right">
            <h5 class="slot-text">Spots Details as of {{checkEndDate}}</h5>
            <div class="stats-main-right-inner">
                <div class="flex-grow-1 lg:flex-grow-1 sm:flex-grow-0 sm:flex-shrink-0 custom-shrink">
                    <div class="booking-main custom-bokingmain">
                        <div class="left-text">
                            <div class="booking-status">
                                <div class="new-bookingtext spot-occupancy">
                                    <img src="assets/images/slots-occupancy.svg" alt="" />
                                    <div class="slot-outer">
                                        <h4>Spots Occupancy</h4>
                                        <p>(Only monthly bookings)</p>
                                    </div>
                                </div>
                                <ul class="total-booking1">
                                    <li>
                                        <span class="common-circle1 blue-circle"> {{occupiedCount || 0}}%</span>
                                        <p>Occupied</p>
                                    </li>
                                    <li>
                                        <span class="common-circle1 grey-circle">{{vacantCount || 0}}%</span>
                                        <p>Vacant</p>
                                    </li>
                                    <li>
                                        <span class="common-circle1 red-circle"> {{maintenanceCount || 0}}%</span>
                                        <p>Maintenance</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex-grow-1 flex-basis">
                    <div class="booking-main booking-line slot-left-border">

                        <div class="booking-text">
                            <div class="new-bookingtext">
                                <div class="new-bookingtext">
                                    <img src="assets/images/one-time-booking.svg" alt=""/>
                                    <div class="slot-outer">
                                        <h4>Daily Bookings</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="booking-status revenu-common">
                            <ul class="total-booking1">
                                <li>
                                    <h5>
                                        {{oneTimeBookingCount || 0 }}
                                    </h5>
                                </li>
                                <li (click)="dailyBookingsClick()">
                                    <div class="arrow-icon"><img src="assets/images/grey-arrow.svg" alt=""/></div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="flex-grow-1 flex-basis">
                    <div class="booking-main booking-line slot-left-border">
                        <div class="booking-text">
                            <div class="new-bookingtext">
                                <div class="new-bookingtext">
                                    <img src="assets/images/group-spot-count.svg" alt=""/>
                                    <div class="slot-outer">
                                        <h4>Group Spot Count</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="booking-status revenu-common">
                            <ul class="total-booking1">
                                <li>
                                    <h5 class="booking-count-header">
                                        {{groupBookingSlotCounts || 0}}
                                    </h5>

                                </li>
                                <li (click)="groupUserBookingsClick()">
                                    <div class="arrow-icon"><img src="assets/images/grey-arrow.svg" alt=""/></div>
                                </li>

                            </ul>
                            <p class="booking-count"> (In {{groupBookingCount || 0 }} bookings)</p>
                        </div>
                    </div>
                </div>
                <div class="flex-grow-1 flex-basis">
                    <div class="booking-main booking-line slot-left-border">
                        <div class="booking-text">
                            <div class="new-bookingtext">
                                <div class="new-bookingtext">
                                    <img src="assets/images/parker-bookings.svg" alt=""/>
                                    <div class="slot-outer">
                                        <h4>Parker Spot Count</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="booking-status revenu-common">
                            <ul class="total-booking1">
                                <li>
                                    <h5>
                                        {{parkerCount || 0 }}
                                    </h5>
                                </li>
                                <li (click)="parkerBookingsClick()">
                                    <div class="arrow-icon"><img src="assets/images/grey-arrow.svg" alt=""/></div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
